<template>
  <v-container fluid fill-height row>
    <v-layout align-start justify-center class="pa-4">
      <v-flex xs12 sm10 class="column align-center" v-if="data">
        <div class="row justify-center">
          <img src="img/mdkgu.png" alt="MDKGU Logo" width="100">
        </div>
        <br />
        <div class="row justify-center">
          <v-alert
            class="mx-5"
            border="left"
            color="green"
            dark
          >
          <span class="pl-5 font-weight-bold text-h5">E-{{ $t('page_license.operating_license') }}</span>
          <div class="column justify-start pa-5">
            <span v-if="data ? data.license : false" class="text-h6 font-weight-bold">
              {{ $t('page_license.license_no') }} : {{ data.license.no_lesen }}
            </span><br />
            <span v-if="data ? data.license : false" class="text-h6 font-weight-bold">
              {{ $t('page_license.company_name') }} : {{ data.license.nama_s }}
            </span><br />
            <span v-if="data ? data.payment : false" class="text-h6 font-weight-bold">
              {{ $t('page_license.issued_date') }} : {{ data.payment.timestamp | date }}
            </span><br />
            <span v-if="data ? data.payment : false" class="text-h6 font-weight-bold">
              {{ $t('valid_until') }} : {{ '31/12/' + data.payment.paid_until_year }}
            </span><br /><br />
            <span class="pt-4 text-h6 font-weight-bold">
              {{ $t('page_license.digital_license_message', { type: $t('page_license.operating_license') }) }}
            </span>
          </div>
          <div class="col text-right">
            <span class="pt-4 text-caption text-right">
              MDKGU e-Services, {{ new Date().toLocaleString("en-MY") }}
            </span>
          </div>
          </v-alert>
        </div>
      </v-flex>

      <v-flex xs12 sm10 class="column align-center" v-else>
        <div class="row justify-center">
          <img src="img/mdkgu.png" width="100">
        </div>
        <br />
        <div class="row justify-center">
          <v-alert
            class="mx-5 text-center"
            border="left"
            color="orange"
            dark
          >
          <span class="pl-5 pa-5 font-weight-bold text-h5 blink_me">Majlis Daerah Penampang</span>
          <div class="column justify-start pa-5"><br />
             <span class="text-h6 font-weight-bold text-uppercase">
              {{ $t('not_found') }}
            </span><br />
          </div>
          </v-alert>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import vuex from 'vuex'
export default {
  name: 'DigitalLicensePublicOperating',
  async created () {
    if (this.$route.params.id) {
      const decodedId = atob(this.$route.params.id)
      if (decodedId.startsWith(`X`)) {
        this.$router.replace({ name: 'trading-digital-license-id', params: { id: this.$route.params.id } })
      }
    }
    await this.fetchData(this.$route.params)
  },
  computed: {
    ...vuex.mapState({
      data: state => state.pdf.data
    })
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'pdf/fetchData'
    })
  }
}
</script>

<style scoped>
.blink_me {
  animation: blinker 1.5s linear infinite;
}

@keyframes blinker {
  50% { opacity: 0.5; }
}
</style>
